

import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Select, MenuItem, Button, Collapse, Autocomplete, Box, FormControl, Grid, IconButton, Input, InputLabel, List, ListItem, TextField, Typography} from "@mui/material";
import { Camera } from "@mui/icons-material";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { DropdownChangeEvent } from "primereact/dropdown";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND } from "../api/endpoint";
import { getPrevFaultByUserIdData, getUniqueAssetNamesByFamilyId, uploadFiles, createFaultData, getTimesheetByIdData } from "../api/Services/assetServices";
import { getCountryAssetMasterDataList, getFamilyAssetMasterDataList, getRegionByCountryId, getProjectByRegionId } from "../api/Services/masterServie";
import ReusablePrimeButton from "../Component/Buttons/ReusablePrimeButton";
import ReusablePrimeReactDialog from "../Component/Dialog/ReusablePrimeReactDialog";
import { base64ToFile } from "../const/const";
import { CustomMessage } from "../const/Spinner";
import { setLoading } from "../store/CommonSlice";
import { RootState } from "../store/Reduxstore";
import { assetFamilyMaster, CountryMaster, RegionMaster, ProjectMaster } from "../types/assetTypes";

import RefreshIcon from "@mui/icons-material/Refresh";
import { timesheetTypes } from "../types/faultTypes";
import AddRigDialog from "./AddRig";



interface CreateTimeSheetProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setTimesheetId: React.Dispatch<React.SetStateAction<number | null>>;
  timeSheetId: number | null;
  selectedValue: number | null;
  getListOfSelectedProducts: () => void;
}
const CreateTimeSheet: React.FC<CreateTimeSheetProps> = ({
  setOpen,
  setTimesheetId,
  timeSheetId,
  selectedValue,
  getListOfSelectedProducts,
}) => {

const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);
  const [openAddRig, setOpenAddRig] = useState(false);
  const [showCancel, setShowCancel] = useState(timeSheetId === 0);


   const [formData, setFormData] = useState<timesheetTypes>({
    timeSheetId: 0,
    user_id: userDetails?.userId ?? 0,
    name: "",
    currentLocationId: 0,
    countryName: "",
    fromdate: "",
    todate: "",
    regionId: 0,
    projectId: 0,
    projectName: "",
    regionName: "",
    type: "",
    month: "",
    year: "",
    rigs: [], // add rigs in formData if you need them
  });

  console.log("Id:", timeSheetId);


  // Effect to log formData changes
  useEffect(() => {
    console.log("Form Data Updated:", formData);
  }, [formData]);

  // 🔁 Auto-fetch regions & projects when editData is loaded
  useEffect(() => {
    if (formData.currentLocationId) {
      getRegionList(formData.currentLocationId);
    }
  }, [formData.currentLocationId]);

  useEffect(() => {
    if (formData.regionId) {
      getProjectList(formData.regionId);
    }
  }, [formData.regionId]);


  // Effect to fetch timesheet if timeSheetId is present
  useEffect(() => {
    const fetchTimesheet = async () => {
      if (!timeSheetId) return;

      try {
        const response = await getTimesheetByIdData(timeSheetId);

        if (response.status.code === 200 && response.data) {
          const data = response.data;

          setFormData((prev) => ({
            ...prev,
            timeSheetId,
            currentLocationId: data.currentLocationId,
            countryName: data.countryName,
            regionId: data.regionId,
            regionName: data.regionName,
            projectId: data.projectId,
            projectName: data.projectName,
            type: data.type,
            fromdate: data.fromdate,
            todate: data.todate,
            rigs: data.rigs ?? [],
            month: data.month || "", 
            year: data.year || "", 
          }));
        } else {
          console.error("Failed to fetch timesheet:", response.status.message);
        }
      } catch (err) {
        console.error("Error fetching timesheet:", err);
      }
    };

    fetchTimesheet();
  }, [timeSheetId]);
  useEffect(() => {
  if (timeSheetId && timeSheetId !== 0) {
    // Editing mode → open Add Rig automatically
    setOpenDialog(true);
    setOpenAddRig(true);
  } else {
    // Creating new timesheet → keep Add Rig closed
    setOpenAddRig(false);
  }
}, [timeSheetId]);



const handleReset = () => {
  setFormData({
    timeSheetId: 0,
    user_id: userDetails.userId ?? 0, // logged-in user
    name: "",
    currentLocationId: 0,
    countryName: "",
    fromdate: "",
    todate: "",
    regionId: 0,
    projectId: 0,
    projectName: "",
    regionName: "",
    type: "",
  });
};
  const [region, setRegions] = useState<
     { label: string; value: number }[]
    >([{label: "Select a region", value: 0 }]);
     
  
  const [project, setProjects] = useState<
    { label: string; value: string | number }[]
    >([]);
  


  const dispatch = useDispatch(); 
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate(); // Initialize navigation
  
  const [countryName, setCurrentLocation] = useState<
      { label: string; value: number }[]
    >([]);

  useEffect(() => {
      if (countryName.length === 0) getCurrentLocationList(1,PAGESEND);
    }, [countryName]);

  const getCurrentLocationList = async (page: number, rows: number) => {
    
      try {
        const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.currentLocationId,
            label: val.countryName,
          }));
          // updatedData.unshift({ label: "--Select--", value: 0 });
          setCurrentLocation(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      }
    };

    const [familyAssetName, setFamilyAssetName] = useState<{ value: number; label: string }[]>([]);
    const [assetType, setAssetTypeList] = useState<{ value: number; label: string }[]>([]);
    const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);
    
    useEffect(() => {
        if (familyAssetName.length === 0) getAssetTypeList(1,PAGESEND);
      }, [familyAssetName]);

    const getAssetTypeList = async (page: number, rows: number) => {
     
      console.log("Fetching asset types...");
    
      try {
        const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
          familyAssetId: { value: "", matchMode: "startsWith" }
        });
    
        console.log("Asset type response:", data, status);
    
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.familyAssetId,
            label: val.familyName,
          }));
    
          // updatedData.unshift({ label: "--Select--", value: 0 });
    
          setAssetTypeList(updatedData);
          console.log("Updated asset type list:", updatedData);

          setFamilyAssetName(updatedData);
    
        }
      } catch (error: any) {
        console.error("Error fetching asset types:", error);
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } 
    };

const getAssetNameList = async (familyAssetId: number | null | undefined) => {
  if (!familyAssetId) {
    console.warn("Invalid familyAssetId:", familyAssetId);
    return;
  }

  console.log("Fetching asset names for familyAssetId:", familyAssetId);

  try {
    const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);

    if (status?.code === 200 && Array.isArray(data) && data.length > 0) {
      const updatedData: { label: string; value: string }[] = data.map((assetName: string) => ({
        value: assetName,
        label: assetName,
      }));
      // updatedData.unshift({ label: "--Select--", value: "" });
      setAssetNameList(updatedData);
    } else {
      console.log("No asset names found or status is not 200");
    }
  } catch (error: any) {
    console.error("Error fetching asset names:", error);
    CustomMessage(error?.message || "Error fetching asset names", "error", enqueueSnackbar);
  }
};

  const getRegionList = async (currentLocationId: number) => {
    
    try {
        const { data, status } = await getRegionByCountryId(currentLocationId);

        if (status.code === 200 && data?.regions?.length > 0) {
            const updatedData: { label: string; value: number }[] = data.regions.map(
                (val: { regionId: number; regionName: string }) => ({
                    value: val.regionId, // Convert to string
                    label: val.regionName ?? "", // Ensure it's a string
                })
            );
            // updatedData.unshift({ label: "--Select--", value: 0 });
            setRegions(updatedData);
        }  else {
                   // ✅ Set to empty array when no data or non-200 status
                      setRegions([]);
                      setFormData((prev) => ({
                    ...prev,
                    // projectId: "",
                    regionName: ""
                    }));
                    // setProjects([]);
                    // setFormData((prev) => ({
                    //   ...prev,
                    //   // projectId: "",
                    //   projectName: ""
                    // }));
                    }

                         
                     } catch (error: any) {
                      setRegions([]);
                            setFormData((prev) => ({
                          ...prev,
                          // projectId: "",
                          regionName: ""
                        }));
                        // setProjects([]);
                        // setFormData((prev) => ({
                        //   ...prev,
                        //   // projectId: "",
                        //   projectName: ""
                        // }));
                         CustomMessage(error?.message, "error", enqueueSnackbar);
                     } 
    
  }; 
  
  const getProjectList = async (regionId: number) => {
  try {
    const { data, status } = await getProjectByRegionId(regionId);
    const projects = data?.projects || data; // handle both possible structures

    if (status.code === 200 && Array.isArray(projects) && projects.length > 0) {
      const updatedData = projects.map((val: any) => ({
        value: val.projectId,
        label: val.projectName,
      }));

      // ✅ Set the dropdown options first
      setProjects(updatedData);

      // ✅ If editing, preselect the project in the box
      if (formData.projectId) {
        const matched = updatedData.find(
          (p) => p.value === formData.projectId
        );
        if (matched) {
          setFormData((prev) => ({
            ...prev,
            projectName: matched.label,
            projectId: matched.value,
          }));
        }
      }
    } else {
      setProjects([]);
      setFormData((prev) => ({ ...prev, projectName: "" }));
    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  }
  };


  const [openDialog, setOpenDialog] = useState(false);
  

 
const [selectedPayload, setSelectedPayload] = useState<any>(null);

const handleSubmit = () => {
  const payload = {
    timeSheetId: formData.timeSheetId ?? 0,
    user_id: userDetails.userId ?? 0,
    currentLocationId: formData.currentLocationId || 0,
    countryName: formData.countryName || "",
    regionId: formData.regionId || 0,
    regionName: formData.regionName || "",
    projectId: formData.projectId || 0,
    projectName: formData.projectName || "",
    type: formData.type || "",
    fromdate: formData.fromdate || "",
    todate: formData.todate || "",
  };

  console.log("Payload before dialog:", payload);

  setSelectedPayload(payload);
  setShowCancel(false);
  setOpenDialog(true);
};


    // const handleSubmit = async (e: React.FormEvent) => {
    // e.preventDefault();

    // const updatedData: timesheetTypes = { ...formData };

    // // Validate required fields
    // if (!updatedData.fromdate || !updatedData.todate) {
    //     CustomMessage("Please select From and To dates.", "error", enqueueSnackbar);
    //     return;
    // }

    // // Default user id
    // updatedData.user_id = userDetails.userId ?? 0;

    // // Build payload strictly according to timesheetTypes
    // const payload: timesheetTypes = {
    //     timeSheetId: updatedData.timeSheetId ?? 0,
    //     user_id: updatedData.user_id,
    //     name: updatedData.name || "",
    //     currentLocationId: updatedData.currentLocationId || 0,
    //     countryName: updatedData.countryName || "",
    //     fromdate: updatedData.fromdate,
    //     todate: updatedData.todate,
    //     regionId: updatedData.regionId || 0,
    //     projectId: updatedData.projectId || 0,
    //     projectName: updatedData.projectName || "",
    //     regionName: updatedData.regionName || "",
    //     type:  updatedData.type || "",
    // };

    // dispatch(setLoading(true));

    // try {
    //     const response = await createTimeSheet(payload); // ✅ should be a timesheet API

    //     console.log("Response:", response);

    //     if (response.status?.code === 201 || response.status?.code === 200) {
    //     CustomMessage(response.status.message, "success", enqueueSnackbar);
    //     } else {
    //     CustomMessage(response.status?.message || "Error occurred", "error", enqueueSnackbar);
    //     }
    // } catch (error: any) {
    //     CustomMessage(error?.message || "Submission failed", "error", enqueueSnackbar);
    // } finally {
    //     dispatch(setLoading(false));
    // }
    // };

  const handleSelectCountryChange = (option: { label: string; value: number } | null) => {
    const updatedData: Partial<timesheetTypes> = { ...formData };

    updatedData.countryName = option?.label || "";
    updatedData.currentLocationId = option?.value || 0;

    // Reset dependent fields
    updatedData.regionId = 0;
    updatedData.regionName = "";
    updatedData.projectId = 0;
    updatedData.projectName = "";

    setFormData(updatedData as timesheetTypes);
    if (updatedData.currentLocationId && updatedData.currentLocationId > 0) {
      getRegionList(updatedData.currentLocationId);
    }
  };

   const handleSelectRegionChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof RegionMaster,
      name2: keyof RegionMaster
    ) => {
      const updatedData: Partial<timesheetTypes> = { ...formData};
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    
      setFormData(updatedData as timesheetTypes);
      getProjectList((e.target as { value: { value: number } }).value?.value || 0);  
};
    


  const handleSelectProjectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof ProjectMaster,
    name2: keyof ProjectMaster
  ) => {
    const updatedData: Partial<timesheetTypes> = { ...formData};
  
    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;   
  
    setFormData(updatedData as timesheetTypes);     
    
    
};

  interface Location {
    latitude: number;
    longitude: number;
  }

  

  

return (
  
  <div>    
    <Box display="flex" alignItems="center" justifyContent="left" width="100%" position="relative">
      {/* <Typography variant="h4" style={styles.heading}>Time Sheet</Typography> */}
      <IconButton onClick={handleReset} style={{ position: "absolute", right: 0, color: "#004489" }}>
        <RefreshIcon />
      </IconButton>
    </Box>
    <div style={styles.container}>
      <form>
        <Grid container spacing={5} rowSpacing={3} columnSpacing={2} style={{ width: "100%" }}> 
            <Grid item xs={12} sm={6} md={3}>
                <label style={styles.label}>Current Location</label>
                <Autocomplete
                fullWidth
                options={countryName}
                getOptionLabel={(option) => option.label || ""}
                value={countryName.find(opt => opt.value === formData.currentLocationId) || null}
                onChange={(_event, newValue) => {
                    handleSelectCountryChange(newValue);
                }}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    placeholder="Select Current Location"
                    variant="outlined"
                    style={{ background: "#fff", borderRadius: 5 }}
                    />
                )}
                />

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <label style={styles.label}>Region</label>
                <Autocomplete
                  fullWidth
                  options={region}
                  filterOptions={(options, state) =>
                    options.filter(opt =>
                      opt.label.toLowerCase().includes(state.inputValue.toLowerCase())
                    )
                  }
                  getOptionLabel={(option) => option.label || ""}
                  value={region.find(opt => opt.value === formData.regionId) || null}
                  onChange={(_event, newValue) => {
                    handleSelectRegionChange(
                      { target: { value: newValue || null } },
                      "regionName",
                      "regionId"
                    );
                  }}
                  isOptionEqualToValue={(option, value) => option?.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select a Region"
                      variant="outlined"
                      style={{ background: "#fff", borderRadius: 5 }}
                    />
                        )}
                      />

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <label style={styles.label}>Project</label>
                <Autocomplete
                    fullWidth
                    options={project}
                    getOptionLabel={(option) => option.label || ""}
                    value={project.find(opt => opt.value === formData.projectId) || null}
                    onChange={(_event, newValue) => {
                    handleSelectProjectChange(
                        { target: { value: newValue || null } },
                        "projectName",
                        "projectId"
                    );
                    }}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Select a Project"
                        variant="outlined"
                        style={{ background: "#fff", borderRadius: 5 }}
                    />
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Type</label>
            <Autocomplete
                fullWidth
                options={[
                { label: "Internal", value: "Internal" },
                { label: "External", value: "External" },
                ]}
                getOptionLabel={(option) => option.label}
                value={
                formData.type
                    ? { label: formData.type, value: formData.type }
                    : null
                }
                onChange={(_event, newValue) =>
                setFormData({
                    ...formData,
                    type: newValue ? newValue.value : "",
                })
                }
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Select Type"
                    variant="outlined"
                    style={{ background: "#fff", borderRadius: 5 }}
                />
                )}
            />
            </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>From</label>
            <Calendar
              value={formData.fromdate ? new Date(formData.fromdate) : null}
              onChange={(e) => {
                const date = e.value ? dayjs(e.value) : null;

                setFormData({
                  ...formData,
                  fromdate: date ? date.format("YYYY-MM-DD") : "",
                  
                });
              }}
              showIcon
              dateFormat="mm/dd/yy"
              placeholder="Select From Date"
            />
          </Grid>

             <Grid item xs={12} sm={6} md={3}>
              <label style={styles.label}>To</label>
              <Calendar
                value={formData.todate ? new Date(formData.todate) : null}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    todate: e.value ? dayjs(e.value).format("YYYY-MM-DD") : "",
                  })
                }
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="Select To Date"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <label style={styles.label}>Month</label>
              <TextField
                fullWidth
                value={formData.month || ""}
                placeholder="Enter Month"
                variant="outlined"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    month: e.target.value,
                  })
                }
                style={{ background: "#fff", borderRadius: 5 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <label style={styles.label}>Year</label>
              <TextField
                fullWidth
                value={formData.year || ""}
                placeholder="Enter Year"
                variant="outlined"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    year: e.target.value,
                  })
                }
                inputProps={{ maxLength: 4 }}
                style={{ background: "#fff", borderRadius: 5 }}
              />
            </Grid>


            


  
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
            {userDetails.role.some(
              (r) => r.roleName === "Admin" || r.roleName === ""
            ) && (
              <>
                {/* 👇 Cancel only when creating and before submit */}
                {showCancel && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setOpen(false)} // closes CreateTimeSheet
                  >
                    Cancel
                  </Button>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </>
            )}
          </Grid>

        </Grid>
        </form>
    </div>
    
    <AddRigDialog
      open={openDialog}
      setOpen={setOpen}
      onClose={() => setOpenDialog(false)}
      fromdate={formData.fromdate}
      todate={formData.todate}
      payload={formData} 
      onResetParent={handleReset}
      editData={formData?.rigs} 
      month={formData.month} 
      year={formData.year}
    />
  </div>
  
  )  
  };
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "",
    width: "",
    margin: "",
    padding: "15px",
    border: "1px solid #eee",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    textAlign: "left",
    color: "#333",
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  formGroup: {
    marginBottom: "10px",
    width: "100%",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    display: "block",
    marginBottom: "3px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};

export default CreateTimeSheet;

